enum RoleType {
	Admin = 'Admin',
	Customer = 'Customer',
}

export default RoleType;
